export enum Techniques {
  rosaRobot = 'Robô Rosa',
  makoRobot = 'Robô Mako',
  robotic = 'Robótica',
  video = 'Vídeo',
  conventional = 'Convencional',
  laser = 'Laser'
}

export const techniquesList = [
  {
    label: Techniques.conventional,
    value: 'conventional'
  },
  {
    label: Techniques.video,
    value: 'video'
  },
  {
    label: Techniques.robotic,
    value: 'robotic'
  },
  {
    label: Techniques.makoRobot,
    value: 'makoRobot'
  },
  {
    label: Techniques.rosaRobot,
    value: 'rosaRobot'
  },
  {
    label: Techniques.laser,
    value: 'laser'
  }
]

/**
 * Mapeia o valor (key do enum) para o label legível.
 * Ex.: getTechniqueLabel('rosaRobot') -> 'Robô Rosa'
 *
 * Retorna o próprio valor se a técnica não for reconhecida (em vez de fallback
 * silencioso para 'Vídeo' como nos códigos legados).
 */
export const getTechniqueLabel = (value?: string): string => {
  if (!value) return ''
  return Techniques[value as keyof typeof Techniques] ?? value
}
